import { FC } from "react";
import ProfilesList from "@/pages/settings/profiles/profiles.page.list";

const SettingsProfilesPage: FC = () => {
    return (
        <div key="profile_management_wrapper" className="profile_management_wrapper">
            <ProfilesList></ProfilesList>
        </div>
    );
};

export default SettingsProfilesPage;
